import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
class Leanerdetails extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="leaner-info-result-sec">
        <div className="container-fluid">
          <div className="align-center d-flex justify-between leaner-info-report-details">
            <div className="d-flex pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Branch</p>
                <span id="leanerBranch"></span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>UUID</p>
                <div
                  className="d-flex w-100 align-center"
                  id="leaneruuid"
                ></div>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Course Progress</p>
                <div
                  className="d-flex w-100 align-center"
                  id="leanerProgress"
                ></div>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Date of Enrollment</p>
                <span className="align-center d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.7"
                    height={13}
                    viewBox="0 0 11.7 13"
                  >
                    <path
                      id="Icon_material-date-range"
                      data-name="Icon material-date-range"
                      d="M8.4,8.85H7.1v1.3H8.4Zm2.6,0H9.7v1.3H11Zm2.6,0H12.3v1.3h1.3ZM14.9,4.3h-.65V3h-1.3V4.3H7.75V3H6.45V4.3H5.8A1.294,1.294,0,0,0,4.507,5.6L4.5,14.7A1.3,1.3,0,0,0,5.8,16h9.1a1.3,1.3,0,0,0,1.3-1.3V5.6A1.3,1.3,0,0,0,14.9,4.3Zm0,10.4H5.8V7.55h9.1Z"
                      transform="translate(-4.5 -3)"
                      fill="#2e3e4e"
                      opacity="0.6"
                    />
                  </svg>
                  <span id="leanerEnrollment"></span>
                </span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Completion Date</p>
                <span className="align-center d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.7"
                    height={13}
                    viewBox="0 0 11.7 13"
                  >
                    <path
                      id="Icon_material-date-range"
                      data-name="Icon material-date-range"
                      d="M8.4,8.85H7.1v1.3H8.4Zm2.6,0H9.7v1.3H11Zm2.6,0H12.3v1.3h1.3ZM14.9,4.3h-.65V3h-1.3V4.3H7.75V3H6.45V4.3H5.8A1.294,1.294,0,0,0,4.507,5.6L4.5,14.7A1.3,1.3,0,0,0,5.8,16h9.1a1.3,1.3,0,0,0,1.3-1.3V5.6A1.3,1.3,0,0,0,14.9,4.3Zm0,10.4H5.8V7.55h9.1Z"
                      transform="translate(-4.5 -3)"
                      fill="#2e3e4e"
                      opacity="0.6"
                    />
                  </svg>
                  <span id="leanerCompletion"></span>
                </span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Time Spent</p>
                <span className="align-center d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.143"
                    height={13}
                    viewBox="0 0 11.143 13"
                  >
                    <path
                      id="Icon_material-timer"
                      data-name="Icon material-timer"
                      d="M11.929,1.5H8.214V2.738h3.714ZM9.452,9.548H10.69V5.833H9.452Zm4.971-4.092.879-.879A6.84,6.84,0,0,0,14.43,3.7l-.879.879a5.571,5.571,0,1,0,.873.873Zm-4.352,7.806A4.333,4.333,0,1,1,14.4,8.929,4.33,4.33,0,0,1,10.071,13.262Z"
                      transform="translate(-4.5 -1.5)"
                      fill="#2e3e4e"
                      opacity="0.6"
                    />
                  </svg>
                  <span id="leanerTimespent"></span>
                </span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Grade</p>
                <span className="text-center" id="leanerGrade"></span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Score</p>
                <span className="text-center" id="leanerScore"></span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl25 pr25 text-nowrap">
              <div className="leaner-report-subtxt">
                <p>Certificate Released</p>
                <span
                  className="align-center d-flex text-center"
                  id="leanerCertificatereleased"
                ></span>
              </div>
            </div>
            <div className="brdr-rght-line"></div>
            <div className="d-flex pl20">
              <div className="leaner-report-subtxt">
                <p>Last Visited Date</p>
                <span className="align-center d-flex">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.7"
                    height={13}
                    viewBox="0 0 11.7 13"
                  >
                    <path
                      id="Icon_material-date-range"
                      data-name="Icon material-date-range"
                      d="M8.4,8.85H7.1v1.3H8.4Zm2.6,0H9.7v1.3H11Zm2.6,0H12.3v1.3h1.3ZM14.9,4.3h-.65V3h-1.3V4.3H7.75V3H6.45V4.3H5.8A1.294,1.294,0,0,0,4.507,5.6L4.5,14.7A1.3,1.3,0,0,0,5.8,16h9.1a1.3,1.3,0,0,0,1.3-1.3V5.6A1.3,1.3,0,0,0,14.9,4.3Zm0,10.4H5.8V7.55h9.1Z"
                      transform="translate(-4.5 -3)"
                      fill="#2e3e4e"
                      opacity="0.6"
                    />
                  </svg>
                  <span id="leanerLastVistedDate"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(WithSystem(Leanerdetails));
